import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import { FaTimes } from 'react-icons/fa';

const StockExit = ({ produtoSelecionado = null, fecharModal = null, isModal = false }) => {
    const [produtos, setProdutos] = useState([]);
    const [filteredProdutos, setFilteredProdutos] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [estoqueAtual, setEstoqueAtual] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [mensagemSucesso, setMensagemSucesso] = useState('');
    
    const modalRef = useRef(null);

    const [saida, setSaida] = useState({
        produto_id: '',
        nome_produto: '',
        codigo_barras: '',
        quantidade: '',
        motivo: 'Utilização na produção'
    });

    useEffect(() => {
        carregarProdutos();
    }, []);

    useEffect(() => {
        if (produtoSelecionado) {
            setSaida(prev => ({
                ...prev,
                produto_id: produtoSelecionado.id,
                nome_produto: produtoSelecionado.nome,
                codigo_barras: produtoSelecionado.codigo_barras
            }));
            setEstoqueAtual(produtoSelecionado.estoque_atual || 0);
            setShowDropdown(false);
        }
    }, [produtoSelecionado]);

    // Fechar modal ao clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                if (fecharModal) fecharModal();
            }
        };

        if (isModal) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [isModal, fecharModal]);

    const carregarProdutos = () => {
        api.get('/produtos')
            .then(response => setProdutos(response.data))
            .catch(error => console.error("Erro ao buscar produtos:", error));
    };

    const handleNomeChange = (e) => {
        const nomeDigitado = e.target.value;
        setSaida({ ...saida, nome_produto: nomeDigitado });

        if (nomeDigitado.length > 0) {
            const produtosFiltrados = produtos.filter(p =>
                p.nome.toLowerCase().includes(nomeDigitado.toLowerCase())
            );
            setFilteredProdutos(produtosFiltrados);
            setShowDropdown(true);
        } else {
            setShowDropdown(false);
            resetEstoque();
        }
    };

    const handleCodigoBarrasChange = (e) => {
        const codigoDigitado = e.target.value;
        setSaida({ ...saida, codigo_barras: codigoDigitado });

        if (codigoDigitado.length > 0) {
            const produtosFiltrados = produtos.filter(p =>
                p.codigo_barras.includes(codigoDigitado) ||
                (p.codigo_barras_alternativo && p.codigo_barras_alternativo.includes(codigoDigitado))
            );
            setFilteredProdutos(produtosFiltrados);
            setShowDropdown(true);
        } else {
            setShowDropdown(false);
            resetEstoque();
        }
    };

    const handleProdutoSelect = (produto) => {
        setSaida({
            ...saida,
            produto_id: produto.id,
            nome_produto: produto.nome,
            codigo_barras: produto.codigo_barras,
        });
        setEstoqueAtual(produto.estoque_atual || 0);
        setShowDropdown(false);
    };

    const resetEstoque = () => {
        setEstoqueAtual(0);
    };

    const handleQuantidadeChange = (e) => {
        const valor = e.target.value.replace(/\D/g, '');
        setSaida({ ...saida, quantidade: valor });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!saida.produto_id) {
            setErrorMessage('Selecione um produto válido antes de registrar a saída.');
            return;
        }

        try {
            const response = await api.post('/movimentacoes', { 
                ...saida, 
                tipo: 'saida',
                quantidade: parseInt(saida.quantidade)
            });
        
            if (response.status === 200 || response.status === 201) {
                setMensagemSucesso('Saída registrada com sucesso!');
                carregarProdutos();
                setSaida({
                    produto_id: '',
                    nome_produto: '',
                    codigo_barras: '',
                    quantidade: '',
                    motivo: 'Utilização na produção'
                });
                setEstoqueAtual(0);
                setErrorMessage('');
        
                setTimeout(() => {
                    setMensagemSucesso('');
                    if (fecharModal) fecharModal();
                }, 2000);
            }
        } catch (error) {
            console.error("Erro ao registrar movimentação:", error);
            if (error.response && error.response.data && error.response.data.erro) {
                setErrorMessage(error.response.data.erro);
            } else {
                setErrorMessage('Erro desconhecido ao registrar saída.');
            }
        }
    };

    // Renderizar formulário
    const renderFormulario = () => (
        <>
            {mensagemSucesso && (
                <div className="mb-3 p-2 bg-green-100 text-green-700 border border-green-400 rounded text-sm">
                    {mensagemSucesso}
                </div>
            )}

            {errorMessage && (
                <div className="mb-3 p-2 bg-red-100 text-red-700 border border-red-400 rounded text-sm">
                    {errorMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-3">
                <div className="relative">
                    <label className="block text-sm text-gray-700 font-medium mb-1">
                        Nome do Produto
                    </label>
                    <input
                        type="text"
                        name="nome_produto"
                        value={saida.nome_produto}
                        autoComplete="off"
                        onChange={handleNomeChange}
                        placeholder="Digite o nome do produto..."
                        className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                        required
                        disabled={!!produtoSelecionado}
                    />
                    {showDropdown && filteredProdutos.length > 0 && (
                        <ul className="absolute w-full border rounded-lg bg-white shadow-md mt-1 z-20 max-h-32 overflow-y-auto">
                            {filteredProdutos.map(produto => (
                                <li
                                    key={produto.id}
                                    className="px-3 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                                    onClick={() => handleProdutoSelect(produto)}
                                >
                                    <span className="block truncate">{produto.nome}</span>
                                    <span className="text-xs text-gray-500">{produto.codigo_barras}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div>
                    <label className="block text-sm text-gray-700 font-medium mb-1">
                        Código de Barras
                    </label>
                    <input
                        type="text"
                        name="codigo_barras"
                        value={saida.codigo_barras}
                        autoComplete="off"
                        onChange={handleCodigoBarrasChange}
                        placeholder="Digite o código de barras..."
                        className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                        required
                        disabled={!!produtoSelecionado}
                    />
                </div>

                <div className="flex justify-between text-sm bg-gray-50 p-2 rounded">
                    <p className="text-gray-700">
                        <strong>Estoque Atual:</strong> {estoqueAtual}
                    </p>
                    <p className="text-red-700">
                        <strong>Estoque Final:</strong> {Math.max(estoqueAtual - (parseInt(saida.quantidade) || 0), 0)}
                    </p>
                </div>

                <div>
                    <label className="block text-sm text-gray-700 font-medium mb-1">
                        Quantidade
                    </label>
                    <input
                        type="text"
                        name="quantidade"
                        value={saida.quantidade}
                        autoComplete="off"
                        onChange={handleQuantidadeChange}
                        placeholder="Digite a quantidade..."
                        className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm text-gray-700 font-medium mb-1">
                        Motivo da Saída
                    </label>
                    <select
                        name="motivo"
                        value={saida.motivo}
                        onChange={(e) => setSaida({ ...saida, motivo: e.target.value })}
                        className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                        required
                    >
                        <option value="">Selecione o motivo</option>
                        <option value="Utilização na produção">Utilização na produção</option>
                        <option value="Inventário">Inventário</option>
                        <option value="Venceu / Estragou">Venceu / Estragou</option>
                        <option value="Desperdício na produção">Desperdício na produção</option>
                        <option value="Testes culinários">Testes culinários</option>
                        <option value="Doação">Doação</option>
                        <option value="Perda não identificada">Perda não identificada</option>
                    </select>
                </div>

                <button 
                    type="submit"
                    className="w-full bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600 transition-colors text-sm font-medium mt-4"
                >
                    Registrar Saída
                </button>
            </form>
        </>
    );

    // MODO MODAL
    if (isModal) {
        return (
            <div 
                className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4"
                style={{ zIndex: 9999 }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        fecharModal();
                    }
                }}
            >
                <div 
                    ref={modalRef}
                    className="bg-white rounded-lg shadow-lg w-full max-w-md relative"
                    style={{ 
                        maxHeight: '95vh',
                        overflowY: 'auto'
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="sticky top-0 bg-white border-b px-4 py-3 flex items-center justify-between rounded-t-lg z-10">
                        <h2 className="text-lg font-semibold text-gray-700">
                            Registrar Saída de Estoque
                        </h2>
                        <button
                            type="button"
                            onClick={fecharModal}
                            className="text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full p-2 transition-colors flex-shrink-0"
                            aria-label="Fechar"
                        >
                            <FaTimes className="w-5 h-5" />
                        </button>
                    </div>

                    <div className="p-4">
                        {renderFormulario()}
                    </div>
                </div>
            </div>
        );
    }

    // MODO PÁGINA COMPLETA
    return (
        <div className="max-w-lg mx-auto mt-10 bg-white p-6 md:p-8 rounded-lg shadow-lg relative">
            <h2 className="text-xl md:text-2xl font-semibold text-center text-gray-700 mb-4 md:mb-6">
                Registrar Saída de Estoque
            </h2>
            {renderFormulario()}
        </div>
    );
};

export default StockExit;